import { render } from "./pagination.vue?vue&type=template&id=fc68b128"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"
script.render = render

export default script